require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
require('../modules/core.iter-helpers');
module.exports = require('../modules/$').core.isIterable;


/*****************
 ** WEBPACK FOOTER
 ** /code/~/core-js/library/fn/is-iterable.js
 ** module id = 808
 ** module chunks = 0
 **/